import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import { Input, Button } from '@baseV2'
import { strings } from '@constants'
import { Spacings } from '@styles'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	font-family: ${({ theme }) => theme.fontFamily.inter};
`

const Body = styled.div`
	flex: 1;
	padding: ${Spacings.SPACING_4B};
`

const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_4B};
	border-top: 1px solid ${({ theme }) => theme.colors.border.default};
`

// Single-field search drawer for the Payment list — filter by organisation (optional, free text).
const SearchPayment = ({ close }) => {
	const [searchParams, setSearchParams] = useSearchParams()
	const [searchText, setSearchText] = useState(searchParams.get('organisationId') || '')

	const closeDrawer = () => close?.()

	const applyFilter = () => {
		const value = searchText.trim()
		const next = new URLSearchParams(searchParams)
		if (value) next.set('organisationId', value)
		else next.delete('organisationId')
		next.delete('page')
		setSearchParams(next)
		closeDrawer()
	}

	const clearFilter = () => {
		const next = new URLSearchParams(searchParams)
		next.delete('organisationId')
		next.delete('page')
		setSearchParams(next)
		setSearchText('')
		closeDrawer()
	}

	return (
		<Wrapper>
			<Body>
				<Input
					type='search'
					label={strings('organisation')}
					placeholder='Search by Id / Name / Mobile'
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
					onKeyDown={(e) => e.key === 'Enter' && applyFilter()}
				/>
			</Body>
			<Footer>
				<Button variant='outline' color='neutral' size='small' onClick={clearFilter}>
					{strings('clear')}
				</Button>
				<Button color='primary' size='small' onClick={applyFilter}>
					{strings('search')}
				</Button>
			</Footer>
		</Wrapper>
	)
}

export default SearchPayment
